{
  "locales": [
    "en",
    "es",
    "pt",
    "fr",
    "ru",
    "ar",
    "de",
    "it",
    "zh-cn",
    "ja",
    "ko",
    "hu",
    "sk",
    "pl",
    "bg",
    "cs",
    "da",
    "nl",
    "et",
    "fi",
    "id",
    "lv",
    "lt",
    "no",
    "ro",
    "sl",
    "sv",
    "tr",
    "uk",
    "hi",
    "bn",
    "ms",
    "sq",
    "hy",
    "az",
    "be",
    "am",
    "ur",
    "ka",
    "he",
    "th",
    "vi",
    "af",
    "sm",
    "debug"
  ],
  "locales_temp": [
    "en",
    "es",
    "pt",
    "fr",
    "ru",
    "ar",
    "de",
    "it",
    "zh-cn",
    "zh-tw",
    "ja",
    "ko",
    "hu",
    "sk",
    "pl",
    "bg",
    "cs",
    "da",
    "nl",
    "et",
    "fi",
    "el",
    "id",
    "lv",
    "lt",
    "no",
    "ro",
    "sl",
    "sv",
    "tr",
    "uk",
    "hi",
    "bn",
    "pa",
    "ms",
    "ps",
    "sq",
    "hy",
    "az",
    "be",
    "km",
    "am",
    "ur",
    "ka",
    "fa",
    "he",
    "kk",
    "sw",
    "ky",
    "lo",
    "mk",
    "mn",
    "ne",
    "rw",
    "ta",
    "si",
    "tg",
    "th",
    "tk",
    "uz",
    "vi",
    "my",
    "af",
    "ti",
    "dv",
    "mt",
    "sm"
  ],
  "prefix": "ROUTES."
}
